import axios from 'axios';

const service = axios.create({
  //
});

service.interceptors.request.use(
  config => {
    // if (store.getters._token) {
    //   // axios.defaults.headers.common.Authorization = 'Bearer ' + store.getters._token
    //   if (!config.headers["Authorization"]) {
    //     config.headers['X-Requested-With'] = 'XMLHttpRequest';
    //     config.headers['Authorization'] = 'Bearer ' + store.getters._token;
    //   }
    // }
    
    //-- convert null values to void for post requests:
    if (config.method == 'post' && config.data instanceof FormData) {
      for (var key of config.data.keys()) {
        // here you can add filtering conditions
        if (config.data.get(key) == null || config.data.get(key) == "null") { //?wtf null converts to string "null"
          config.data.delete(key); // -> void 0
        }
      }
    }

    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export default service;
